import type { Book } from './books';
import { latestBrandReleases } from '../../../shared/brand-latest/latestReleases';

export const latestBooks2026: Book[] = latestBrandReleases
  .filter((book) => book.brandSlug === 'fuke-culture')
  .map((book) => ({
    slug: book.id,
    title: book.title,
    subtitle: book.subtitle,
    author: book.author,
    category: book.category,
    format: '電子書',
    description: book.summary,
    suitableReaders: '',
    tags: [book.category],
    dataStatus: '已確認' as Book['dataStatus'],
    coverImage: book.coverImage,
    isbn: book.isbn,
    publishDate: book.publishDate,
  }));
